/**************************************************************************
Name:         deferLoad.js
Description:  Site scripting.
Date Created: 2016-02-29 by Sophie Orta
Modified:
**************************************************************************/

/* Template support - DO NOT REMOVE */
window.jQuery || document.write( '<script src="/scripts/jquery-1.8.1.min.js"><\/script>' );

var h = document.getElementsByTagName('head')[0];

// var raf = requestAnimationFrame || mozRequestAnimationFrame || webkitRequestAnimationFrame || msRequestAnimationFrame;
// var loadHandler;

// if (raf) {
// 	loadHandler = function(elfn){ raf(elfn) };
// }
// else {
// 	loadHandler = function(elfn){ window.addEventListener('load', elfn); };
// }

var styleFn = function(loc) {
	return function() {
		var l = document.createElement('link');
		l.rel = 'stylesheet';
		l.type = 'text/css';
		l.href = loc;
		h.appendChild(l);
	};
};

var scriptFn = function(loc) {
	return function() {
		var s = document.createElement('script');
		s.type = "text/javascript";
		s.src = loc;
		h.appendChild(s);
	};
};

var styleFn2 = function(loc) {
	return function() {
		document.write( '<link rel="stylesheet" type="text/css" href="' + loc + '"\/>' );
	};
};

var scriptFn2 = function(loc) {
	return function() {
		document.write( '<script type="text/javascript" src="' + loc + '"><\/script>' );
	};
};

for( var i = 0; i < loadStyles.length; i++ ) {
	// loadHandler(styleFn2(loadStyles[i]));
	styleFn(loadStyles[i])();
}

for( let s of loadScripts ) {
	// loadHandler(scriptFn2(loadScripts[i]));
	scriptFn(s)();
}

$('img[data-src]').each(function(index, el) {
	var thisImg = $(this);
	thisImg.attr('src', thisImg.attr('data-src'));
});

$( window ).load( function( ){
	for( var i = 0; i < loadEvents.length; i++ ) {
		loadEvents[i]( );
	}
});
